export default __webpack_public_path__ + "static/media/json.4056b8fd.svg";